import {Injectable} from '@angular/core';

@Injectable()
export class AnexoIn {
  fileInBase64: string;
  descricao: string;
  nomeArquivo: string;
  constructor() {
  }
}
